import { type TimeSlot } from "@clipboard-health/contract-worker-app-bff";
import { type Theme } from "@mui/material";
import { Card } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import { getGradientByTimeSlot } from "../getGradientByTimeSlot";

interface HighlightedWorkerShiftCardWrapperProps {
  children: React.ReactNode;
  shiftTimeSlot: TimeSlot;
}

export function HighlightedWorkerShiftCardWrapper(props: HighlightedWorkerShiftCardWrapperProps) {
  const { children, shiftTimeSlot } = props;

  return (
    <Card
      sx={{
        flexGrow: 1,
        ...(isRebrandingEnabled()
          ? {
              background: (theme: Theme) => theme.palette.background.primary,
            }
          : {
              background: (theme: Theme) =>
                getGradientByTimeSlot({ timeSlot: shiftTimeSlot, theme }),
            }),
      }}
      variant="tertiary"
    >
      {children}
    </Card>
  );
}
